export const microservices = {
    localBaseUrl: 'http://msblocks.seliselocal.com/api',
    devBaseUrl: 'https://pcx.seliselocal.com/api',
    stgBaseUrl: 'https://ipex-audit-center.selisestage.com/api',
    prodBaseUrl: 'https://app.ipex.ch/api',
    aggregator: {
        urlPrefix: 'aggregator',
        dev: 'v6',
        stg: 'v4',
        prod: 'v100'
    }, 
    tenant: {
        urlPrefix: 'tenant',
        dev: 'v2',
        stg: 'v2',
        prod: 'v100'
    },
    mailService: {
        urlPrefix: 'mailService',
        dev: 'v12',
        stg: 'v15',
        prod: 'v100'
    },
    storageService: {
        urlPrefix: 'storageService',
        dev: 'v22',
        stg: 'v23',
        prod: 'v100'
    },
    notification: {
        urlPrefix: 'notification',
        dev: 'v3',
        stg: 'v3',
        prod: 'v100'
    },
    appCatalogue: {
        urlPrefix: 'appCatalogue',
        dev: 'v3',
        stg: 'v1',
        prod: 'v100'
    },
    pdfGenerator2: {
        urlPrefix: 'pdfGenerator2',
        dev: 'v24',
        stg: 'v26',
        prod: 'v100'
    },
    identity: {
        urlPrefix: 'identity',
        dev: 'v20',
        stg: 'v25',
        prod: 'v100'
    },
    uam: {
        urlPrefix: 'uam',
        dev: 'v23',
        stg: 'v33',
        prod: 'v100'
    },
    pds: {
        urlPrefix: 'pds',
        dev: 'v1',
        stg: 'v1',
        prod: 'v100'
    },
    templateEngine: {
        urlPrefix: 'templateEngine',
        dev: 'v17',
        stg: 'v21',
        prod: 'v100'
    },
    gqlCommand: {
        urlPrefix: 'gqlCommand',
        dev: 'v7',
        stg: 'v7',
        prod: 'v100'
    },
    gqlQuery: {
        urlPrefix: 'gqlQuery',
        dev: 'v7',
        stg: 'v7',
        prod: 'v100'
    },
    captcha: {
        urlPrefix: 'captcha',
        dev: 'v1',
        stg: 'v1',
        prod: 'v100'
    },
    emailSyncService: {
        urlPrefix: 'business-emailsync',
        dev: '',
        stg: '',
        prod: ''
    },
    pcxBusinessService: {
        urlPrefix: 'business-pcx',
        dev: '',
        stg: '',
        prod: ''
    }
};
